<section class="features-container" [class.open]="isOpen" (blur)="isOpen = false">
  <div class="features-header" (click)="toggleState()">
    <h2>{{infoDescriptionTitle}}</h2>
    <button class="arrow" [attr.aria-label]="infoDescriptionTitle">
      <icon name="carrot_arrow"></icon>
    </button>
  </div>
  <div class="features-body">
    <div class="features-content">
      @if (showDescription) {
        <p class="text">{{ description }}</p>
      }
      @if (showOptions) {
        <ul class="features-list-item">
          @for (floor of optionsByFloor; track floor) {
            <li class="text" [attr.tabindex]="isOpen ? 0: -1">
              {{floor.Title}}
              <ul>
                @for (option of floor.ActionSets; track option) {
                  @if (option.IsInMenu) {
                    <li>
                      {{ option.Name }}
                    </li>
                  }
                }
              </ul>
            </li>
          }
          @if (noOptionsMessage) {
            <li>{{noOptionsMessage}}</li>
          }
        </ul>
      }
    </div>
  </div>
</section>